import { useState } from "react";
import { useTranslation } from "@i18n";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import type { Sla } from "@ServerTypes/sla/sla.schema";
import { SlaCard } from "./SlaCard";

export function SlaSection({ sla, onRefresh }: { sla?: Sla | null; onRefresh?: () => Promise<void> | void }) {
  const { t } = useTranslation();
  const [refreshing, setRefreshing] = useState(false);

  if (!sla) {
    return <div className="text-sm text-text_light">{t("SLA — awaiting triage.")}</div>;
  }

  const handleRefresh = () => {
    if (!onRefresh || refreshing) return;
    setRefreshing(true);
    void Promise.resolve(onRefresh()).finally(() => setRefreshing(false));
  };

  return (
    <div className="flex flex-col gap-4 pe-4">
      <SlaCard variant="response" clock={sla.response} />
      <SlaCard variant="resolution" clock={sla.resolution} />

      {onRefresh && (
        <div className="flex items-center justify-start gap-4">
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} loading={refreshing} onClick={handleRefresh}>
            <div className="flex items-center gap-2">
              {!refreshing && <IconComponent name="refresh" width="1rem" height="1rem" />}
              {t("Refresh")}
            </div>
          </ButtonComponent>
        </div>
      )}
    </div>
  );
}
